import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../_Services/index';

@Component({
    moduleId: module.id,
    templateUrl: 'forgotpassword.component.html'
})

export class ForgotpasswordComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService) { }

    ngOnInit() {
        // reset login status 
    }

    reset() {
        this.loading = true;
        this.authenticationService.resetPassword(this.model.email)
            .subscribe(result => {
                if (result === true) {
                    this.router.navigate(['/auth/login']);
                } else {
                    this.error = 'Invalid email address';
                    this.loading = false;
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/forgotpassword.component.ts